export default __webpack_public_path__ + "static/media/06-upgrade-your-system.3bc195c4.jpg";